import React from "react";
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";
import Text from "components/atoms/Text";
import { Drug } from "common/models/types";
import { getDateStringFromToday } from "utils/TimeUtil";
import Icon from "components/atoms/Icon";

interface MedicationItemProps {
  medication: Drug;
  isSelected: boolean;
  onClick: () => void;
}

// 의약품 목록 아이템 스타일
const StyledMedicationItem = styled.div<{ isSelected: boolean }>`
  padding: 16px;
  border-bottom: 1px solid ${COLOR_SYSTEM.get("Gray")?.[200]};
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? COLOR_SYSTEM.get("Blue")?.[100] : "white")};
  transition: background-color 0.2s ease;
  position: relative;

  &:hover {
    background-color: ${({ isSelected }) =>
      isSelected ? COLOR_SYSTEM.get("Blue")?.[150] : COLOR_SYSTEM.get("Gray")?.[100]};
  }
`;

const CheckIcon = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  color: ${COLOR_SYSTEM.get("Green")?.[500]};
  font-size: 14px;
`;

const ItemCode = styled.div`
  font-size: 10px;
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
`;

const ProductName = styled.div<{ isSelected: boolean }>`
  font-weight: ${({ isSelected }) => (isSelected ? "600" : "500")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
  line-height: 1.4;
  max-width: 320px;
`;

const InfoLine = styled.div`
  font-size: 12px;
  color: ${COLOR_SYSTEM.get("Gray")?.[600]};
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
`;

const MedicationItem: React.FC<MedicationItemProps> = ({ medication, isSelected, onClick }) => {
  return (
    <StyledMedicationItem isSelected={isSelected} onClick={onClick}>
      {medication.crawledAt && (
        <CheckIcon title={getDateStringFromToday({ date: medication.crawledAt.toString() })}>
          <Icon name="Check Filled" size={16} color={COLOR_SYSTEM.get("Green")?.[500]} />
        </CheckIcon>
      )}
      <ItemCode>
        {medication.itemCode || "코드 없음"} | {medication.standardCode || "표준코드 없음"}
      </ItemCode>
      <ProductName isSelected={isSelected} title={medication.productName}>
        {medication.productName}
      </ProductName>
      <InfoLine
        title={`${medication.companyName || "제조사 정보 없음"} | ${
          medication.mainIngredient || "성분 정보 없음"
        }`}
      >
        {medication.companyName || "제조사 정보 없음"} |{" "}
        {medication.mainIngredient || "성분 정보 없음"}
      </InfoLine>
    </StyledMedicationItem>
  );
};

export default MedicationItem;
